function _parse(s) {
    return parseInt(s, 16);
}
export function mergeUuids(uuid1, uuid2) {
    var newId = '';
    for (var i = 0; i < uuid1.length; i++) {
        var c = uuid1[i];
        if (c === '-')
            newId += '-';
        // eslint-disable-next-line no-bitwise
        else
            newId += (_parse(c) ^ _parse(uuid2[i]) % 16).toString(16);
    }
    return newId;
}
